import { useState, useEffect } from 'react'
import { getTitlesAPI } from '../services/titles'
function UseEmpsTitle() {
  const [data, setData] = useState([])
  useEffect(() => {
    const getData = async () => {
      const result = await getTitlesAPI()
      if (!result) return

      const newData = result.result.map((d, i) => {
        return {
          en: d.title_en,
          th: d.title_th,
          id: d.id,
          sex: d.sex,
          sexId: d.sex_id
        }
      })

      setData(newData)
    }
    getData()
  }, [])

  return data
}

export default UseEmpsTitle
